import { render } from "./LeavePreventPopup.vue?vue&type=template&id=563622e5&ts=true"
import script from "./LeavePreventPopup.ts?vue&type=script&lang=ts"
export * from "./LeavePreventPopup.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__